import React from "react";
import { Lock, CheckCircle2, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function PhaseModule({ icon: Icon, title, phase, description, planned = [], dependsOn = [] }) {
  const navigate = useNavigate();
  return (
    <div className="p-8 fade-up">
      <div className="flex items-center gap-3 mb-2">
        <div className="w-11 h-11 rounded-xl bg-[#212534] flex items-center justify-center">
          <Icon size={22} className="text-[#E6B04E]" />
        </div>
        <div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight">{title}</h1>
          <span className="metric-label">Planned · Phase {phase}</span>
        </div>
      </div>

      <div className="studio-card p-6 mt-6 max-w-3xl">
        <div className="flex items-center gap-2 mb-3 text-[#94A3B8]">
          <Lock size={16} className="text-[#F59E0B]" />
          <span className="text-sm font-medium">This module is scheduled for Phase {phase} and is not yet implemented.</span>
        </div>
        <p className="text-[#94A3B8] text-sm leading-relaxed mb-5">{description}</p>

        {planned.length > 0 && (
          <div className="mb-5">
            <div className="metric-label mb-2">Planned capabilities</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {planned.map((f) => (
                <div key={f} className="flex items-center gap-2 text-sm text-[#CBD5E1]">
                  <CheckCircle2 size={14} className="text-[#334155] shrink-0" /> {f}
                </div>
              ))}
            </div>
          </div>
        )}

        {dependsOn.length > 0 && (
          <div className="mb-5">
            <div className="metric-label mb-2">Builds on</div>
            <div className="flex flex-wrap gap-2">{dependsOn.map((d) => <span key={d} className="tech-badge">{d}</span>)}</div>
          </div>
        )}

        <div className="pt-4 border-t border-[#252A3B] flex items-center justify-between">
          <span className="text-[12px] text-[#64748B]">Phase 1 foundation (import, scan, proxy, jobs, storage) is live now.</span>
          <button className="btn btn-ghost !py-2 !px-3 text-[13px]" onClick={() => navigate("/media")}>
            Go to Media <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
}
